import theme from "../../themes/green";

const styles = {
  wrapper: {
    backgroundColor: theme.pallete.lightBackground,
    position: "relative",
    maxWidth: "200px",
    minWidth: "200px",
    zIndex: 1,
    flex: 2
  },
  heading: {
    padding: 10,
    fontSize: 11,
    fontWeight: 600,
    width: "100%",
    color: theme.pallete.background
  },
  project: {
    minWidth: 150,
    width: 200
  },
  track: {
    height: 5,
    bottom: 0,
    left: 0,
    right: 0
  },
  thumb: {
    background: theme.pallete.scrollbar
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/ProjectWidgets/styles.js